<template>
  <section class="auth-screen">
    <section class="auth-card">
      <aside class="auth-intro">
        <div class="auth-brand">
          <span class="brand-mark">TJ</span>
          <div class="brand-copy">
            <strong>TestJob</strong>
            <span>管理台</span>
          </div>
        </div>

        <div class="auth-intro-copy">
          <h1>接口流程工作台</h1>
          <div class="auth-signal-list">
            <span><el-icon><Tickets /></el-icon>Job</span>
            <span><el-icon><SetUp /></el-icon>Flow</span>
            <span><el-icon><DocumentChecked /></el-icon>Rule</span>
          </div>
        </div>
      </aside>

      <section class="auth-panel">
        <div class="auth-panel-head">
          <span>{{ authMode === 'register' ? '创建账号' : '账号登录' }}</span>
          <strong>{{ authMode === 'register' ? '注册' : '登录' }}</strong>
        </div>

        <el-radio-group :model-value="authMode" class="auth-mode" @update:model-value="setAuthMode">
          <el-radio-button label="login">登录</el-radio-button>
          <el-radio-button label="register">注册</el-radio-button>
        </el-radio-group>

        <el-form class="auth-form" label-position="top" @submit.prevent="handleAuthSubmit">
          <el-form-item label="用户名">
            <el-input
              :model-value="authForm.username"
              maxlength="64"
              autocomplete="username"
              size="large"
              @update:model-value="updateAuthField('username', $event)"
            >
              <template #prefix>
                <el-icon><User /></el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input
              :model-value="authForm.password"
              type="password"
              maxlength="128"
              show-password
              :autocomplete="authMode === 'register' ? 'new-password' : 'current-password'"
              size="large"
              @update:model-value="updateAuthField('password', $event)"
            >
              <template #prefix>
                <el-icon><Lock /></el-icon>
              </template>
            </el-input>
          </el-form-item>
          <el-button
            class="auth-submit"
            type="primary"
            native-type="submit"
            size="large"
            :loading="authenticating"
          >
            {{ authMode === 'register' ? '注册并进入' : '登录' }}
            <el-icon class="auth-submit-icon"><ArrowRight /></el-icon>
          </el-button>
        </el-form>
      </section>
    </section>
  </section>
</template>

<script>
// AuthPage only owns the login/register UI. Vuex keeps the auth state and API flow centralized.
import { mapActions, mapMutations, mapState } from "vuex";
import {
  ArrowRight,
  DocumentChecked,
  Lock,
  SetUp,
  Tickets,
  User,
} from "@element-plus/icons-vue";

export default {
  name: "AuthPage",

  components: {
    ArrowRight,
    DocumentChecked,
    Lock,
    SetUp,
    Tickets,
    User,
  },

  computed: {
    ...mapState(["authenticating", "authForm", "authMode"]),
  },

  methods: {
    ...mapActions(["submitAuth"]),
    ...mapMutations({
      setAuthMode: "setAuthMode",
      setAuthFormField: "setAuthFormField",
    }),

    updateAuthField(field, value) {
      // Keep Vuex as the single source of truth for the auth form.
      this.setAuthFormField({ field, value });
    },

    handleAuthSubmit() {
      this.submitAuth(this.authMode);
    },
  },
};
</script>
